module.exports = __webpack_public_path__ + "img/box-back.a7532fa1.png";